<template>
  <div class="export-pdf-container export-pdf-container-wth">
    <div class="content content-wth">
      <table class="common-table">
        <template
          v-for="(criteria, criteriaIndex) in programCategoryRating.criteria"
        >
          <tr
            :key="'top-page-break-' + criteriaIndex"
            class="top-page-break page-break-pdf"
            v-if="criteriaIndex === 14 || criteriaIndex === 22"
          ></tr>
          <tr
            class="tr-sub"
            :key="'tr-sub' + criteriaIndex"
            v-if="
              (orderNumber === 2 || orderNumber === 6) && criteriaIndex >= 7
            "
          >
            <td class="order-number">
              {{ orderNumber }}.{{ criteriaIndex + 1 }}
            </td>
            <td>
              <p class="table-text-big">
                {{ criteria.criterion ? criteria.criterion.name : "" }}
              </p>
              <p class="table-text-small">
                {{ criteria.criterion ? criteria.criterion.description : "" }}
              </p>
            </td>
            <td class="td-weight">{{ criteria.weight | formatNumber }}</td>
            <td class="td-rating-level">
              {{ criteria.min_point }}-{{ criteria.benchmark
              }}{{ criteria.programt }}
            </td>
            <td class="td-real-data">{{ criteria.achievement }}</td>
            <td class="td-score">{{ criteria.score | formatNumber }}</td>
            <td class="td-stars">
              <p v-if="!criteria.star || criteria.star == '0'">
                N/A
              </p>
              <img
                v-else
                class="table-star-small"
                style="max-width: 150px"
                alt=""
                :src="
                  `img/icon-rating/${getCategoryStarImg(
                    programInfo.program_type_id === 1 ? 'research' : 'applied',
                    criteria.star
                  )}`
                "
              />
            </td>
          </tr>

          <tr
            class="tr-sub"
            :key="'tr-sub' + criteriaIndex"
            v-if="orderNumber !== 2 && orderNumber !== 6 && criteriaIndex >= 6"
          >
            <td class="order-number">
              {{ orderNumber }}.{{ criteriaIndex + 1 }}
            </td>
            <td>
              <p class="table-text-big">
                {{ criteria.criterion ? criteria.criterion.name : "" }}
              </p>
              <p class="table-text-small">
                {{ criteria.criterion ? criteria.criterion.description : "" }}
              </p>
            </td>
            <td class="td-weight">{{ criteria.weight }}</td>
            <td class="td-rating-level">
              {{ criteria.min_point }}-{{ criteria.benchmark
              }}{{ criteria.programt }}
            </td>
            <td class="td-real-data">{{ criteria.achievement }}</td>
            <td class="td-score">{{ criteria.score }}</td>
            <td class="td-stars">
              <p v-if="!criteria.star || criteria.star == '0'">
                N/A
              </p>
              <img
                v-else
                class="table-star-small"
                style="max-width: 150px"
                alt=""
                :src="
                  `img/icon-rating/${getCategoryStarImg(
                    programInfo.program_type_id === 1 ? 'research' : 'applied',
                    criteria.star
                  )}`
                "
              />
            </td>
          </tr>
        </template>
      </table>

      <div
        v-if="
          (orderNumber === 2 ||
            programCategoryRating.criteria.length < 4 ||
            (programCategoryRating.criteria.length < 12 &&
              programCategoryRating.criteria.length >= 7)) &&
            orderNumber !== 6
        "
        class="text-center last-img-center"
      >
        <img
          class="last-page-picture"
          :class="[{ 'last-page-picture-max-height': orderNumber === 2 }]"
          :src="`img/imgPdf/${getCategoryPicture(orderNumber)}`"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CriterionRatingWithoutHeader",
  props: {
    orderNumber: {
      type: Number
    },
    programCategoryRating: {
      type: Object
    },
    programInfo: {
      type: Object
    }
  },
  methods: {
    getCategoryStarImg(divisionName, star = "") {
      const displayStar = star && star >= 1 ? parseInt(star) : 1;
      return `${divisionName}_${displayStar}.svg`;
    },
    getCategoryPicture(orderNumber) {
      return `category${orderNumber}.png`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/program-pdf.scss";
</style>
